import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertService } from '@app/_services';
import { ActivatedRoute, Router } from "@angular/router";
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ProformaService } from '../proforma.service';
import { Proforma } from '../proforma';
import { ProformaComponent } from '../proforma/proforma.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as moment from 'moment';
import { ProformaGeneratesComponent } from '../Proforma-generates/proforma-generates.component';
import { ProformaCopyFromFormComponent } from '../proforma-copy-from-form/proforma-copy-from-form.component';

@Component({
    selector: 'app-proforma-list',
    templateUrl: './proforma-list.component.html',
    styleUrls: ['./proforma-list.component.css'],
    providers: [DialogService, MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ProformaListComponent implements OnInit {
	constructor(
		private proformaService: ProformaService,
		private alertService: AlertService,
		private messageService: MessageService,
		private route: ActivatedRoute,
		private router: Router,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService,
		private dialog: MatDialog,
	) {
		this.requestProformaId = this.route.snapshot.params['proformaId'];
		this.statuses = proformaService.statuses
		this.visibilities = proformaService.visibilities;
	}



	// data
	@Input() realtorProfileId: any;
	@Input() ownerLeadProfileId: any;
	@Input() propertyLeadProfileId: any;

	@Input() showFilter = true;
	@Input() showPagination = true;

	@Output() doOpenCopiedProforma = new EventEmitter<any>();

	proformas: any;
	proforma: Proforma;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	visibilities:any;

	requestProformaId: any;

	columns: any[] = [
		// { field: 'propertyCode', header: 'Property Code', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'customAddress', header: 'Address', width: 'auto' },
		{ field: 'preparedDate', header: 'Prepared Date', width: 'auto' },
		{ field: 'createdBy', header: 'Created By', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'visibility', header: 'Visibility', width: 'auto' },
		{ field: 'realtorName', header: 'Realtor', width: 'auto' },
		{ field: 'homeOwner', header: 'Home Owner', width: 'auto' },
		{ field: 'expandYrGrossTtl', header: 'Expand Gross Ttl', width: 'auto' },
		{ field: 'stableYrGrossTtl', header: 'Stable Gross Ttl', width: 'auto' },
		{ field: 'contractYrGrossTtl', header: 'Contract Gross Ttl', width: 'auto' },
		{ field: 'viewCount', header: 'Views', width: 'auto' },
		{ field: 'lastViewedAt', header: 'Last Viewed', width: 'auto' },

	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}

		this.route.queryParams.subscribe(params => {
			const olpId = params['ownerLeadProfileId'] ? +params['ownerLeadProfileId'] : null;
			const plpId = params['propertyLeadProfileId'] ? +params['propertyLeadProfileId'] : null;
			if (olpId) {
				this.ownerLeadProfileId = olpId;
				if (plpId) this.propertyLeadProfileId = plpId;
				setTimeout(() => {
					this.onOpenFormAdd();
					this.router.navigate([], {
						relativeTo: this.route,
						queryParams: {},
						replaceUrl: true
					});
				}, 300);
			}
		});
	}

	getFilteredTags(tags) {
		//if filter text input is empty then load all records
		if(tags == '0') {
			delete this.lazyLoadEvent.filters.proformaId;
			this.loadLazy(this.lazyLoadEvent);
		} else {
			//If records found then show filtered records
			if(tags.length > 0) {
				//if filter text input is not empty then load filtered records only
				var filteredIds = [];
				tags.forEach(tag => {
					filteredIds.push(tag.tagSourceId);
				});
				let activityProviderIdFilter = { 'proformaId': { 'value': filteredIds, 'matchMode': 'in' } };
				Object.assign(this.lazyLoadEvent.filters, activityProviderIdFilter);
				this.loadLazy(this.lazyLoadEvent);
			} else {
				//Display empty table as no record found with filtered input
				this.proformas = [];
			}
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.proformaId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event; // auto loading list without referesh page 

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-proforma-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			if(this.realtorProfileId)
			{
				// show only proformas that are assigned to this realtorProfileId
				let realtorProfileIdFilter = { 'realtorProfileVO.realtorProfileId': { 'value': this.realtorProfileId, 'matchMode': 'in' } };
				Object.assign(event.filters, realtorProfileIdFilter);
			}
			if(this.ownerLeadProfileId)
			{
				// show only proformas that are assigned to this ownerLeadProfileId
				let ownerLeadProfileIdFilter = { 'ownerProfileLeadVO.ownerLeadProfileId': { 'value': this.ownerLeadProfileId, 'matchMode': 'in' } };
				Object.assign(event.filters, ownerLeadProfileIdFilter);
			}
			// if(this.propertyLeadProfileId)
			// {
			// 	// show only proformas that are assigned to this propertyLeadProfileId
			// 	let propertyLeadProfileIdFilter = { 'propertyLeadProfileId': { 'value': this.propertyLeadProfileId, 'matchMode': 'in' } };
			// 	Object.assign(event.filters, propertyLeadProfileIdFilter);
			// }
			
			const pageNumber = Math.round(event.first / event.rows);
			this.proformaService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						res.data.proformas.forEach(proforma => {
							//For proforma request dialog
							if(proforma.realEstateProperty != undefined && proforma.status == 4) {
								var addressStreetNumber = proforma.realEstateProperty?.addressStreetNumber != undefined ? (proforma.realEstateProperty?.addressStreetNumber) : '';
								var subjAdrStreet = proforma.realEstateProperty?.addressStreetName != undefined ? (proforma.realEstateProperty?.addressStreetName) : '';
								var subjAdrUnit = proforma.realEstateProperty?.addressUnit != undefined ? ('#'+proforma.realEstateProperty?.addressUnit) : '';
								var subjAdrCity = proforma.realEstateProperty?.addressCity != undefined ? (proforma.realEstateProperty?.addressCity + ',') : '';
								var subjAdrState = proforma.realEstateProperty?.addressState != undefined ? (proforma.realEstateProperty?.addressState) : '';
							
								proforma.customAddress = addressStreetNumber + ' ' + subjAdrStreet + ' ' + subjAdrUnit + ' ' + 
													subjAdrCity + ' ' + subjAdrState
							} else {
								//For regular proforma dialog
								var subjAdrStreet = proforma.propertyLeadProfile?.subjAdrStreet != undefined ? (proforma.propertyLeadProfile?.subjAdrStreet) : '';
								var subjAdrUnit = proforma.propertyLeadProfile?.subjAdrUnit != undefined ? ('#'+proforma.propertyLeadProfile?.subjAdrUnit) : '';
								var subjAdrCity = proforma.propertyLeadProfile?.subjAdrCity != undefined ? (proforma.propertyLeadProfile?.subjAdrCity + ',') : '';
								var subjAdrState = proforma.propertyLeadProfile?.subjAdrState != undefined ? (proforma.propertyLeadProfile?.subjAdrState) : '';
							
								proforma.customAddress = subjAdrStreet + ' ' + subjAdrUnit + ' ' + 
													subjAdrCity + ' ' + subjAdrState
							}
						});
						this.proformas = res.data.proformas;
						// Fetch view stats per row (async, non-blocking)
						this.proformas.forEach((proforma: any) => {
							if (proforma.proformaId) {
								this.proformaService.getViewStats(proforma.proformaId).subscribe({
									next: (statsRes: any) => {
										proforma.viewCount = statsRes?.data?.viewStats?.viewCount ?? 0;
										proforma.lastViewedAt = statsRes?.data?.viewStats?.lastViewedAt ?? null;
									},
									error: () => { /* silently ignore */ }
								});
							}
						});
						console.log(JSON.stringify(res.page));
						let editProforma = null;
						if(this.requestProformaId != undefined) {
							this.proformas.forEach(proforma => {
								if(editProforma == null && proforma.proformaId == this.requestProformaId) {
									editProforma = proforma;
								}
							});
						}
						if(editProforma != null) {
							this.onOpenFormEdit(editProforma);
						}
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.proformas = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(proforma: Proforma) {
		try {
			this.formLoading = true;
			this.proformaService.update(proforma)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.proformas.map((proforma, i) => {
							if (proforma.proformaId === res.data.proforma.proformaId) {
								this.proformas[i] = res.data.proforma;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(proforma: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(proforma));

			this.formLoading = true;
			this.proformaService.delete(proforma.proformaId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.proformas.splice(this.proformas.indexOf(proforma), 1);
						this.recordTotal = this.proformas.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Proforma ' + proforma.proformaId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'Proforma ' + proforma.proformaId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Generate proformas
		 *
		 */
	onOpenGenerateProformaForm() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Generate Proformas'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaGeneratesComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addProformaCB(data);

				// close the dialogBox
				//dialogRef.close();
			});
	}

	/**
	 * Generate (copy) proforma from existing list of proformas and assign given owner lead profile
	 */
	onOpenCopyAndGenerateProforma() {
	
		const ref = this.dialogService.open(ProformaCopyFromFormComponent, {
			data: {
				proforma: this.proforma,
				ownerLeadProfileId: this.ownerLeadProfileId
			},
			header: "Copy From",
			width: "auto",
		});

		ref.onClose.subscribe((copiedProforma: any) => {
			if(copiedProforma != undefined) {
					this.loadLazy(this.lazyLoadEvent);
					this.onOpenFormEdit(copiedProforma);
				}
		});
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.width = "80vw";
		dialogConfig.maxWidth = "100vw";
		// dialogConfig.height = "100vh";
		// dialogConfig.maxHeight = "100vh";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add Proforma',
			realtorProfileId: this.realtorProfileId,
			ownerLeadProfileId: this.ownerLeadProfileId,
			propertyLeadProfileId: this.propertyLeadProfileId
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addProformaCB(data);

				// close the dialogBox
				//dialogRef.close();
			});

		// to open the copied proforma
		dialogRef.componentInstance.doOpenCopiedProforma.subscribe(
			data => {
				console.log('doOpenCopiedProforma Dialog output:', data);
				// close the dialogBox
				if(data != undefined) {
					this.loadLazy(this.lazyLoadEvent);
					this.onOpenFormEdit(data);
					dialogRef.close();
				}
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(proforma: Proforma) {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.width = "100vw";
		dialogConfig.maxWidth = "1600px";
		// dialogConfig.height = "80vh";
		// dialogConfig.maxHeight = "100vh";
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			proforma: proforma,
			title: 'Edit Proforma'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				//this.updateProformaCB(data);
				this.loadLazy(this.lazyLoadEvent);

				// close the dialogBox
				// dialogRef.close();
			});

		// to open the copied proforma
		dialogRef.componentInstance.doOpenCopiedProforma.subscribe(
			data => {
				console.log('doOpenCopiedProforma Dialog output:', data);
					// close the dialogBox
					if(data != undefined) {
						this.loadLazy(this.lazyLoadEvent);
						this.onOpenFormEdit(data);
						dialogRef.close();
					}
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteProformaCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addProformaCB(proforma: Proforma) {
		console.log('Adding Proforma: ' + JSON.stringify(proforma));
		// if we don't have a proformas array yet...
		if (!this.proformas) {
			this.proformas = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.proformas.unshift(proforma);

		// no idea what this is but it is required to update the array
		this.proformas = [...this.proformas];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma.proformaId + ' Added', life: 3000 });
	}

	updateProformaCB(proforma: Proforma) {
		console.log('Updating Proforma: ' + JSON.stringify(proforma));
		let itemIndex = this.proformas.findIndex((item: any) => item.proformaId === proforma.proformaId);
		//proforma.preparedDate = moment(this.proforma.preparedDate).toDate();
		this.proformas[itemIndex] = proforma;

		// no idea what this is but it is required to update the array
		this.proformas = [...this.proformas];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma.proformaId + ' Updated', life: 3000 });
	}

	deleteProformaCB(proforma: Proforma) {
		console.log('Removing Proforma: ' + proforma);
		this.proformas.splice(this.proformas.indexOf(proforma), 1);
		this.recordTotal = this.proformas.length;

		// no idea what this is but it is required to update the array
		this.proformas = [...this.proformas];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma.proformaId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.proformas ? this.first === (this.proformas.length - this.rows) : true; }
	isFirstPage(): boolean { return this.proformas ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(proforma: any) {
		if (proforma?.status != undefined) {
			const status = this.statuses.find((e: any) => e.value == proforma.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	getVisibilityName(proforma: any) {
		if (proforma?.visibility != undefined) {
			const visibility = this.visibilities.find((e: any) => e.value == proforma.visibility);
			return visibility.name;
		}
		else {
			return '';
		}
	}
	
	composeVisible = false;
	composeRow: any = null;

	sendToProspect(row: any) {
		this.composeRow = row;
		this.composeVisible = true;
	}

	copyPublicLink(proforma: any) {
		const url = 'https://www.kbmresorts.com/bizdev/' + proforma.confId;
		navigator.clipboard.writeText(url).then(() => {
			this.messageService.add({ severity: 'success', summary: 'Copied', detail: 'Public link copied to clipboard', life: 3000 });
		}).catch(() => {
			this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to copy link', life: 3000 });
		});
	}

	reloadPage() {
		window.location.reload();
	}
	
	showPaginator()
	{
		return true;
	}

}
